const allIso7010SignCodes = [
  'E001',
  'E002',
  'E003',
  'E004',
  'E005',
  'E006',
  'E007',
  'E008',
  'E009',
  'E010',
  'E011',
  'E012',
  'E013',
  'E014',
  'E015',
  'E016',
  'E017',
  'E018',
  'E019',
  'E020',
  'E021',
  'E022',
  'E023',
  'E024',
  'E025',
  'E026',
  'E027',
  'E028',
  'E029',
  'E030',
  'E031',
  'E032',
  'E033',
  'E034',
  'E035',
  'E037',
  'E038',
  'E039',
  'E041',
  'E042',
  'E043',
  'E045',
  'E046',
  'E047',
  'E048',
  'E049',
  'E050',
  'E051',
  'E052',
  'E053',
  'E054',
  'E055',
  'E056',
  'E057',
  'E058',
  'E059',
  'E060',
  'E061',
  'E062',
  'E063',
  'E064',
  'E065',
  'E067',
  'E068',
  'E069',
  'E070',
  'E071',
  'E072',
  'E073',
  'E074',
  'E075',
  'E076',
  'F001',
  'F002',
  'F003',
  'F004',
  'F005',
  'F006',
  'F007',
  'F008',
  'F009',
  'F010',
  'F011',
  'F012',
  'F013',
  'F014',
  'F015',
  'F016',
  'F017',
  'F018',
  'F019',
  'M001',
  'M002',
  'M003',
  'M004',
  'M005',
  'M006',
  'M007',
  'M008',
  'M009',
  'M010',
  'M011',
  'M012',
  'M013',
  'M014',
  'M015',
  'M016',
  'M017',
  'M018',
  'M019',
  'M020',
  'M021',
  'M022',
  'M023',
  'M024',
  'M025',
  'M026',
  'M027',
  'M028',
  'M029',
  'M030',
  'M031',
  'M032',
  'M033',
  'M034',
  'M035',
  'M036',
  'M037',
  'M038',
  'M039',
  'M040',
  'M041',
  'M042',
  'M043',
  'M044',
  'M045',
  'M046',
  'M047',
  'M048',
  'M049',
  'M050',
  'M051',
  'M052',
  'M053',
  'M054',
  'M055',
  'M056',
  'M057',
  'M058',
  'M059',
  'M060',
  'M061',
  'M062',
  'M063',
  'M064',
  'M065',
  'M066',
  'M067',
  'M068',
  'M069',
  'M070',
  'M071',
  'M072',
  'P001',
  'P002',
  'P003',
  'P004',
  'P005',
  'P006',
  'P007',
  'P008',
  'P009',
  'P010',
  'P011',
  'P012',
  'P013',
  'P014',
  'P015',
  'P016',
  'P017',
  'P018',
  'P019',
  'P020',
  'W001',
  'W002',
  'W003',
  'W004',
  'W005',
  'W006',
  'W007',
  'W008',
  'W009',
  'W010',
  'W011',
  'W012',
  'W013',
  'W014',
  'W015',
  'W016',
  'W017',
  'W018',
  'W019',
  'W020',
  'W021',
  'W022',
  'W023',
  'W024',
  'W025',
  'W026',
  'W027',
  'W028',
  'W029',
  'W030',
  'W031',
  'W032',
  'W033',
  'W034',
  'W035',
  'W036',
  'W037',
  'W038',
  'W039',
  'W040',
  'W041',
  'W042',
  'W043',
  'W045',
  'W046',
  'W047',
  'W048',
  'W049',
  'W050',
  'W051',
  'W052',
  'W053',
  'W054',
  'W055',
  'W056',
  'W057',
  'W058',
  'W059',
  'W060',
  'W061',
  'W062',
  'W063',
  'W064',
  'W065',
  'W066',
  'W067',
  'W068',
  'W069',
  'W070',
  'W071',
  'W072',
  'W073',
  'W074',
  'W075',
  'W076',
  'W077',
  'W078',
  'W079',
  'W080',
  'W082',
  'W083',
  'W084',
  'W085',
  'W087',
  'W088',
  'W089',
] as const;

export type Iso7010SignCode = (typeof allIso7010SignCodes)[number];

export const iso7010SignDescriptions = {
  E001: 'Emergency exit (left hand)',
  E002: 'Emergency exit (right hand)',
  E003: 'First aid',
  E004: 'Emergency telephone',
  E005: 'Direction, arrow (90° increments), safe condition',
  E006: 'Direction, 45° arrow (90° increments), safe condition',
  E007: 'Evacuation assembly point',
  E008: 'Break to obtain access',
  E009: 'Doctor',
  E010: 'Automated external heart defibrillator',
  E011: 'Eyewash station',
  E012: 'Safety shower',
  E013: 'Stretcher',
  E014: 'Child seat presence and orientation detection system (CPOD)',
  E015: 'Drinking water',
  E016: 'Emergency window with escape ladder',
  E017: 'Rescue window',
  E018: 'Turn anticlockwise to open',
  E019: 'Turn clockwise to open',
  E020: 'Emergency stop button',
  E021: 'Protection shelter',
  E022: 'Door opens by pushing on the left-hand side',
  E023: 'Door opens by pushing on the right-hand side',
  E024: 'Evacuation temporary refuge',
  E025: 'Emergency hammer',
  E026: 'Emergency exit for people unable to walk or with walking impairment (left)',
  E027: 'Medical grab bag',
  E028: 'Oxygen resuscitator',
  E029: 'Emergency escape breathing device',
  E030: 'Emergency exit for people unable to walk or with walking impairment (right)',
  E031: 'Shipboard general alarm',
  E032: 'Shipboard assembly station',
  E033: 'Door slides right to open',
  E034: 'Door slides left to open',
  E035: 'Liferaft knife',
  E037: 'Rescue boat',
  E038: 'Liferaft',
  E039: 'Davit-launched liferaft',
  E041: 'Lifebuoy with line',
  E042: 'Lifebuoy with light',
  E043: 'Lifebuoy with line and light',
  E045: "Child's lifejacket",
  E046: "Infant's lifejacket",
  E047: 'Search and rescue transponder',
  E048: 'Survival craft distress signals',
  E049: 'Rocket parachute flare',
  E050: 'Line-throwing appliance',
  E051: 'Two-way VHF radiotelephone apparatus',
  E052: 'Emergency position indicating radio beacon',
  E053: 'Embarkment ladder',
  E054: 'Marine evacuation slide',
  E055: 'Marine evacuation chute',
  E056: 'Survival clothing',
  E057: 'Door opens by pulling on the left-hand side',
  E058: 'Door opens by pulling on the right-hand side',
  E059: 'Escape ladder',
  E060: 'Evacuation chair',
  E061: 'Water life-saving equipment',
  E062: 'Tsunami evacuation area',
  E063: 'Tsunami evacuation building',
  E064: 'First aid responder',
  E065: 'Natural disaster outdoor refuge area',
  E067: 'Evacuation mattress',
  E068: 'Lifebuoy with light and smoke',
  E069: 'Person overboard call point',
  E070: 'Evacuation lift for people unable to use stairs',
  E071: 'Rescue toboggan',
  E072: 'Safe anchorage point',
  E073: 'Emergency descent device',
  E074: 'Emergency rations',
  E075: 'Lifeguard',
  E076: 'Evacuation equipment',
  F001: 'Fire extinguisher',
  F002: 'Fire hose reel',
  F003: 'Fire ladder',
  F004: 'Collection of firefighting equipment',
  F005: 'Fire alarm call point',
  F006: 'Fire emergency telephone',
  F007: 'Fire protection door',
  F008: 'Fixed fire extinguishing battery',
  F009: 'Wheeled fire extinguisher',
  F010: 'Portable foam applicator unit',
  F011: 'Water fog applicator',
  F012: 'Fixed fire extinguishing installation',
  F013: 'Fixed fire extinguishing bottle',
  F014: 'Remote release station',
  F015: 'Fire monitor',
  F016: 'Fire blanket',
  F017: "Firefighters' lift",
  F018: 'Fire alarm flashing light',
  F019: 'Unconnected fire hose',
  M001: 'General mandatory action sign',
  M002: 'Refer to instruction manual/booklet',
  M003: 'Wear ear protection',
  M004: 'Wear eye protection',
  M005: 'Connect an earth terminal to the ground',
  M006: 'Disconnect mains plug from electrical outlet',
  M007: 'Opaque eye protection must be worn',
  M008: 'Wear safety footwear',
  M009: 'Wear protective gloves',
  M010: 'Wear protective clothing',
  M011: 'Wash your hands',
  M012: 'Use handrail',
  M013: 'Wear a face shield',
  M014: 'Wear head protection',
  M015: 'Wear high-visibility clothing',
  M016: 'Wear a mask',
  M017: 'Wear respiratory protection',
  M018: 'Wear a safety harness',
  M019: 'Wear a welding mask',
  M020: 'Wear safety belts',
  M021: 'Disconnect before carrying out maintenance or repair',
  M022: 'Use barrier cream',
  M023: 'Use footbridge',
  M024: 'Use this walkway',
  M025: "Protect infants' eyes with opaque eye protection",
  M026: 'Use protective apron',
  M027: 'Check guard',
  M028: 'Keep locked',
  M029: 'Sound horn',
  M030: 'Use litter bin',
  M031: 'Use table saw adjustable guard',
  M032: 'Wear anti-static footwear',
  M033: 'Close safety bar of chairlift',
  M034: 'Open safety bar of chairlift',
  M035: 'Immediately leave the tow-track in the event of falling',
  M036: 'Lift ski tips',
  M037: 'Close and secure hatches in launch sequence',
  M038: 'Start engine in launch sequence',
  M039: 'Lower lifeboat to the water in launch sequence',
  M040: 'Lower liferaft to the water in launch sequence',
  M041: 'Lower rescue boat to the water in launch sequence',
  M042: 'Release falls in launch sequence',
  M043: 'Start water spray in launch sequence',
  M044: 'Start air supply in launch sequence',
  M045: 'Release lifeboat gripes in launch sequence',
  M046: 'Secure gas cylinders',
  M047: 'Use self-contained breathing appliance',
  M048: 'Use gas detector',
  M049: 'Wear protective roller sport equipment',
  M050: 'Alighting from toboggan to the left',
  M051: 'Alighting from toboggan to the right',
  M052: 'Keep distance between toboggans',
  M053: 'Wear personal flotation devices',
  M054: 'Keep children under supervision in the aquatic environment',
  M055: 'Keep out of the reach of children',
  M056: 'Ventilate before and during entering',
  M057: 'Ensure continuous ventilation',
  M058: 'Entry only with supervisor outside',
  M059: 'Wear laboratory coat',
  M060: 'Hold the trolley handle',
  M061: 'Disinfect your hands',
  M062: 'Disinfect surface',
  M063: 'Remove ski pole strap from wrist',
  M064: 'Hold two ski poles with a single hand',
  M065: 'Children must be accompanied',
  M066: 'Wear a sports helmet',
  M067: 'Wear snow goggles',
  M068: 'Lock moving mechanical parts',
  M069: 'Tools must be tethered',
  M070: 'Use lamp in luminaire with shield',
  M071: 'Use anti-tip restraints',
  M072: 'Use decontamination shower',
  P001: 'General prohibition sign',
  P002: 'No smoking',
  P003: 'No open flame; Fire, open ignition source and smoking prohibited',
  P004: 'No thoroughfare',
  P005: 'Not drinking water',
  P006: 'No access for forklift trucks and industrial vehicles',
  P007: 'No access for people with active implanted cardiac devices',
  P008: 'No metallic articles or watches',
  P009: 'No climbing',
  P010: 'Do not touch',
  P011: 'Do not extinguish with water',
  P012: 'No heavy load',
  P013: 'No activated mobile phone',
  P014: 'No access for people with metallic implants',
  P015: 'No reaching in',
  P016: 'Do not spray with water',
  P017: 'No pushing',
  P018: 'No sitting',
  P019: 'No stepping on surface',
  P020: 'Do not use lift in the event of fire',
  P021: 'No dogs',
  P022: 'No eating or drinking',
  P023: 'Do not obstruct',
  P024: 'Do not walk or stand here',
  P025: 'Do not use this incomplete scaffold',
  P026: 'Do not use this device in a bathtub, shower or water-filled reservoir',
  P027: 'Do not use this lift for people',
  P028: 'Do not wear gloves',
  P029: 'No photography',
  P030: 'Do not tie knots in rope',
  P031: 'Do not alter the state of the switch',
  P032: 'Do not use for face grinding',
  P033: 'Do not use for wet grinding',
  P034: 'Do not use with hand-held grinder',
  P035: 'Do not wear metal-studded footwear',
  P036: 'No children allowed',
  P037: 'Do not leave the tow-track',
  P038: 'Do not swing the chair',
  P039: 'Hot works prohibited',
  P040: 'Do not set off fireworks',
  P041: 'No leaning against',
  P042: 'Not for pregnant women',
  P043: 'Not for people in the state of intoxication',
  P044: 'Use of smart glasses prohibited',
  P045: 'No campfire',
  P046: 'Do not stretch out of toboggan',
  P047: 'Do not ram into toboggans',
  P048: 'No running',
  P049: 'No swimming',
  P050: 'No snorkelling',
  P051: 'No sub-aqua diving',
  P052: 'No diving',
  P053: 'No sailing',
  P054: 'No windsurfing',
  P055: 'No manually powered craft',
  P056: 'No mechanically powered craft',
  P057: 'No personal water craft',
  P058: 'No towed water activity',
  P059: 'No surf craft',
  P060: 'No outdoor footwear',
  P061: 'No jumping into water',
  P062: 'No pushing into water',
  P063: 'No body boarding',
  P064: 'No surfing between the red-and-yellow flags',
  P065: 'No kite surfing',
  P066: 'No parasailing',
  P067: 'No sand yachting',
  P068: 'Do not expose to direct sunlight or hot surface',
  P069: 'Not to be serviced by users',
  P070: 'Do not put finger into the nozzle of a hydromassage',
  P071: 'Do not cross barrier',
  P072: 'No jumping down',
  P073: 'Do not shut lid when burners are operating',
  P074: 'Child seat installation prohibited',
  P075: 'Do not stare at light source',
  P076: 'No skiing',
  P077: 'No snowboarding',
  P078: 'No tobogganing or sledding',
  P079: 'No ice skating',
  P080: 'No access for unauthorized persons',
  P081: 'Do not cover appliance',
  W001: 'General warning sign',
  W002: 'Explosive material',
  W003: 'Radioactive material or ionizing radiation',
  W004: 'Laser beam',
  W005: 'Non-ionizing radiation',
  W006: 'Magnetic field',
  W007: 'Floor-level obstacle',
  W008: 'Drop (fall)',
  W009: 'Biological hazard',
  W010: 'Low temperature/freezing conditions',
  W011: 'Slippery surface',
  W012: 'Electricity',
  W013: 'Guard dog',
  W014: 'Forklift trucks and other industrial vehicles',
  W015: 'Overhead load',
  W016: 'Toxic material',
  W017: 'Hot surface',
  W018: 'Automatic start-up',
  W019: 'Crushing',
  W020: 'Overhead obstacle',
  W021: 'Flammable material',
  W022: 'Sharp element',
  W023: 'Corrosive substance',
  W024: 'Crushing of hands',
  W025: 'Counterrotating rollers',
  W026: 'Battery charging',
  W027: 'Optical radiation',
  W028: 'Oxidizing substance',
  W029: 'Pressurized cylinder',
  W030: 'Hand crushing between press brake tool',
  W031: 'Hand crushing between press brake and material',
  W032: 'Rapid movement of workpiece in press brake',
  W033: 'Barbed wire',
  W034: 'Bull',
  W035: 'Falling objects',
  W036: 'Fragile roof',
  W037: 'Run over by remote operator controlled machine',
  W038: 'Sudden loud noise',
  W039: 'Falling ice',
  W040: 'Roof avalanche',
  W041: 'Asphyxiating atmosphere',
  W042: 'Arc flash',
  W043: 'Thin ice',
  W045: 'Towed water activity area',
  W046: 'Surf craft area',
  W047: 'Deep water',
  W048: 'Shallow water (diving)',
  W049: 'Submerged objects',
  W050: 'Sudden drop in swimming or leisure pools',
  W051: 'Unprotected edge',
  W052: 'Unstable cliff edge',
  W053: 'Unstable cliff',
  W054: 'Shark',
  W055: 'Sewage effluent outfall',
  W056: 'Tsunami hazard zone',
  W057: 'Strong currents',
  W058: 'Boating area',
  W059: 'Sand yachting',
  W060: 'Incoming tides',
  W061: 'Quicksand or mud/deep mud or silt',
  W062: 'Kite surfing',
  W063: 'Parasailing',
  W064: 'Strong winds',
  W065: 'High surf or large breaking waves',
  W066: 'Deep shelving beach',
  W067: 'Crocodiles, alligators or caymans',
  W068: 'Falling into water when stepping on or off a floating surface',
  W069: 'Jellyfish',
  W070: 'Step down',
  W071: 'Substance or mixture presenting a health hazard',
  W072: 'Substance or mixture that can cause an environmental hazard',
  W073: 'Large-scale fire zone',
  W074: 'Tornado zone',
  W075: 'Active volcano zone',
  W076: 'Debris flow zone',
  W077: 'Flood zone',
  W078: 'Landslide zone',
  W079: 'Hot content',
  W080: 'Hot steam',
  W082: 'Crevasses under snow',
  W083: 'Avalanche',
  W084: 'Thunderstorm',
  W085: 'Typhoon/hurricane/cyclone zone',
  W087: 'High sound volume levels',
  W088: 'Moving blades',
  W089: 'Moving gears',
} as const satisfies Record<string, string>;

export type Iso7010SignCategory = {
  title: string;
  icons: Iso7010SignCode[];
};

export const iso7010SignCategories = {
  prohibitionSign: {
    title: 'Prohibition sign',
    icons: [
      'P001',
      'P002',
      'P003',
      'P004',
      'P005',
      'P006',
      'P007',
      'P008',
      'P009',
      'P010',
      'P011',
      'P012',
      'P013',
      'P014',
      'P015',
      'P016',
      'P017',
      'P018',
      'P019',
      'P020',
    ],
  },
  mandatorySign: {
    title: 'Mandatory sign',
    icons: [
      'M001',
      'M002',
      'M003',
      'M004',
      'M005',
      'M006',
      'M007',
      'M008',
      'M009',
      'M010',
      'M011',
      'M012',
      'M013',
      'M014',
      'M015',
      'M016',
      'M017',
      'M018',
      'M019',
      'M020',
    ],
  },
  warningSign: {
    title: 'Warning sign',
    icons: [
      'W001',
      'W002',
      'W003',
      'W004',
      'W005',
      'W006',
      'W007',
      'W008',
      'W009',
      'W010',
      'W011',
      'W012',
      'W013',
      'W014',
      'W015',
      'W016',
      'W017',
      'W018',
      'W019',
      'W020',
    ],
  },
  safeConditionSign: {
    title: 'Safe condition sign',
    icons: [
      'E001',
      'E002',
      'E003',
      'E004',
      'E005',
      'E006',
      'E007',
      'E008',
      'E009',
      'E010',
      'E011',
      'E012',
      'E013',
      'E014',
      'E015',
      'E016',
      'E017',
      'E018',
      'E019',
      'E020',
    ],
  },
  fireSafetySign: {
    title: 'Fire safety sign',
    icons: [
      'F001',
      'F002',
      'F003',
      'F004',
      'F005',
      'F006',
      'F007',
      'F008',
      'F009',
      'F010',
      'F011',
      'F012',
      'F013',
      'F014',
      'F015',
      'F016',
      'F017',
      'F018',
      'F019',
    ],
  },
} as const satisfies Record<string, Iso7010SignCategory>;

export const getIso7010SignImagePath = (code: Iso7010SignCode) =>
  `/signs/ISO_7010_${code.toUpperCase()}.png`;

export const parseSignNames = (signNames?: string): Iso7010SignCode[] => {
  if (!signNames?.trim()) {
    return [];
  }
  return signNames
    .split(',')
    .map((name) => name.trim().toUpperCase())
    .filter((name): name is Iso7010SignCode =>
      (allIso7010SignCodes as readonly string[]).includes(name)
    );
};

export const formatSignNames = (codes: Iso7010SignCode[]): string =>
  codes.map((code) => code.toLowerCase()).join(', ');
